import { fetch } from '@financial-tool/fetch';

export default function setUserAsWelcomed() {
  return fetch.post('/user/me/welcome');
}
